module.exports = __webpack_public_path__ + "img/bj.f00a8e22.svg";